import enums from "../enums";
import Service from "../service/index.jsx";

//TODO: remove tenantId also userId because we have token!
export function getCurrentBalance() {
	return (dispatch) => {
		Service.get("account-api", "balance")
			.then((response) => {
				dispatch({ type: enums.BALANCE_UPDATED, payload: response.data });
				localStorage.setItem("currency", response.data.real.currency);
			})
			.catch((e) => {
				console.log(e);
			});
	};
}

export function getCurrencies() {
	return (dispatch) => {
		Service.get("auth-api", "currencies")
			.then((response) => {
				dispatch({ type: enums.CURRENCIES, payload: response.data?.currencies ?? [] });
			})
			.catch((e) => {
				console.log(e);
			});
	};
}
export function getConversionRates(currency) {
	return (dispatch) => {
		Service.get("wallet-api", "rates", { params: { currency } })
			.then((response) => {
				dispatch({
					type: enums.CONVERSION_RATES,
					payload: response.data?.rates ?? [],
				});
			})
			.catch((e) => {
				console.log(e);
			});
	};
}
